import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'

export type MessagingLabelVariant =
  | 'urgency'
  | 'success'
  | 'warning'
  | 'critical-low'
  | 'critical-high'

const MessagingLabelElement = styled(_BaseLabel)`
  &.variant-urgency {
    background-color: var(--palette-messaging-urgency-normal-background);
    border-color: var(--palette-messaging-urgency-normal-foreground);
    color: var(--palette-messaging-urgency-normal-contrast);
  }

  &.variant-success {
    background-color: var(--palette-messaging-success-light-background);
    border-color: var(--palette-messaging-success-light-foreground);
    color: var(--palette-messaging-success-light-contrast);
  }

  &.variant-warning {
    background-color: var(--palette-messaging-warning-light-background);
    border-color: var(--palette-messaging-warning-light-foreground);
    color: var(--palette-messaging-warning-light-contrast);
  }

  &.variant-critical-low {
    background-color: var(--palette-messaging-critical-light-background);
    border-color: var(--palette-messaging-critical-light-foreground);
    color: var(--palette-messaging-critical-light-contrast);
  }

  &.variant-critical-high {
    background-color: var(--palette-messaging-critical-normal-background);
    border-color: var(--palette-messaging-critical-normal-foreground);
    color: var(--palette-messaging-critical-normal-contrast);
  }
`

interface Props {
  variant: MessagingLabelVariant
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function MessagingLabel({ className, variant, ...labelProps }: PropsWithChildren<Props>) {
  return <MessagingLabelElement
    className={clsx(
      className,
      `variant-${variant}`,
    )}
    {...labelProps}
  />
}

export default MessagingLabel
